/**
 * These are the Case Queue permissions.
 */
export const caseQueuePermissions = {
  Patient: {
    Queue: {
      Write: "caseQueuePatientQueueCanWrite"
    }
  },
  ConsultActions: {
    Case: {
      Write: "caseQueueConsultCanWrite",
      Cancel: "caseQueueConsultCanCancel"
    }
  }
};
